export default "__VITE_ASSET__CEMq2FR___"